<template>
  <div v-if="showLoading">
    <div class="spinner"></div>
  </div>
</template>

<style>
.spinner {
  height: 22px;
  width: 22px;
  animation: rotateSpinner 0.8s infinite linear;
  border: 2px solid black;
  border-right-color: transparent;
  border-radius: 50%;
}

@keyframes rotateSpinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
<script>
export default {
  data() {
    return {
      showLoading: false,
      showTransition: false,
    };
  },
  watch: {
    '$store.state.general.loadingSpinner': function () {
      const self = this;
      if (self.$store.state.general.loadingSpinner) {
        self.showLoading = true;
        self.showTransition = true;
      } else {
        self.showTransition = false;
        setTimeout(() => {
          self.showLoading = false;
        }, 200);
      }
    },
  },
};
</script>
